import { render, staticRenderFns } from "./GridSortControl.vue?vue&type=template&id=27cf8095&scoped=true&"
import script from "./GridSortControl.vue?vue&type=script&lang=ts&"
export * from "./GridSortControl.vue?vue&type=script&lang=ts&"
import style0 from "./GridSortControl.vue?vue&type=style&index=0&id=27cf8095&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf8095",
  null
  
)

export default component.exports